import { FC } from 'react';
import { HelpCircle } from 'lucide-react';

import {
	PunchupTooltip,
	PunchupTooltipProps,
} from 'features/common/components/Punchup/primitives/feedback/PunchupTooltip';
import styles from './PunchupHelpButton.module.css';

export interface PunchupHelpButtonProps extends Omit<PunchupTooltipProps, 'children'> {
	/** HelpCircle icon size in px. Default: 12. */
	iconSize?: number;
}

/**
 * Standard analytics help icon: HelpCircle + PunchupTooltip, self-positioned
 * at the bottom-right corner of the nearest `position:relative` ancestor.
 *
 * Drop it as the last child of any card or tile that has `position:relative`.
 * No wrapper div needed at the callsite.
 */
export const PunchupHelpButton: FC<PunchupHelpButtonProps> = ({
	iconSize = 12,
	triggerLabel = 'More information',
	...tooltipProps
}) => (
	<span className={styles.anchor}>
		{/* triggerLabel makes the icon-only trigger keyboard-focusable + screen-reader-named; the icon is
		    decorative (the tooltip text is the content). */}
		<PunchupTooltip {...tooltipProps} triggerLabel={triggerLabel}>
			<HelpCircle size={iconSize} aria-hidden />
		</PunchupTooltip>
	</span>
);
